import { useMemo } from 'react'

type Props = {
  estimate: number
  className?: string
}

export const EstimateIcon = ({ estimate, className }: Props) => {
  const iconPath = useMemo(() => {
    switch (estimate) {
      case 1:
        return '/images/estimate-one-icon.svg'
      case 2:
        return '/images/estimate-two-icon.svg'
      case 3:
        return '/images/estimate-three-icon.svg'
      default:
        return null
    }
  }, [estimate])

  if (!iconPath) return null

  return <img className={className} src={iconPath} alt={`estimate ${estimate} icon`} />
}
